import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {MatChipInputEvent} from '@angular/material/chips';
import {map, startWith} from 'rxjs/operators';
import {SubscriptionHandler} from '../../../utils/subscription-handler';
import {SegmentService} from '../../segment.service';

const SEPARATOR = ',';
const SEPARATOR_REGEXP = new RegExp(`\s*${SEPARATOR}\s*`);

@Component({
  selector: 'app-keyword-chips',
  templateUrl: './keyword-chips.component.html',
  styleUrls: ['./keyword-chips.component.scss']
})
export class KeywordChipsComponent implements OnChanges, OnInit, OnDestroy {
  @ViewChild('keywordInput') keywordInput!: ElementRef<HTMLInputElement>;

  @Input() tags!: string;
  @Output() tagsChange = new EventEmitter<string>();

  private subscriptionHandler = new SubscriptionHandler();

  separatorKeysCodes: number[] = [ENTER, COMMA];
  keywordCtrl = new FormControl();

  filteredKeywords = this.keywordCtrl.valueChanges.pipe(
    startWith(''),
    map((keyword: string) => (keyword ? this._filter(keyword) : Array.from(this.allKeywords).slice()))
  );

  keywords: Set<string> = new Set<string>();
  allKeywords: Set<string> = new Set<string>();
  keywordsStr!: string;
  bindCount = 0;

  constructor(private segmentService: SegmentService) {
  }

  ngOnInit() {
    // TODO: check if pipe can be used
    this.subscriptionHandler.subscription = this.segmentService.getAllSegments()
      .subscribe(segments => {
        return segments.forEach(segment => {
          return segment.keywords?.split(SEPARATOR_REGEXP)
            .filter(keyword => !this.keywords.has(keyword))
            .forEach(keyword => this.allKeywords.add(keyword));
        });
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['tags'] && changes['tags'].currentValue !== null) {
      if (changes['tags'].currentValue !== this.keywordsStr) {
        this.keywords = new Set(changes['tags'].currentValue?.split(SEPARATOR_REGEXP).filter((x: boolean) => x));
        this.keywordsStr = changes['tags'].currentValue;
      }
    }
  }

  ngOnDestroy() {
    this.subscriptionHandler.unsubscribe();
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim().toLocaleLowerCase();
    this.addKeyword(value);
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.addKeyword(event.option.viewValue);
  }

  addKeyword(value: string) {
    if (value) {
      this.keywords.add(value);
    }
    this.keywordInput.nativeElement.value = '';
    this.keywordCtrl.setValue(null);
    this.updateModel();
  }

  remove(keyword: string): void {
    this.keywords.delete(keyword);
    this.updateModel();
  }

  updateModel() {
    const newVal = Array.from(this.keywords).join(SEPARATOR + ' ');
    this.tagsChange.emit(newVal);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return Array.from(this.allKeywords)
      .filter(keyword => keyword.toLowerCase().includes(filterValue))
      .filter(keyword => !this.keywords.has(keyword));
  }

}
